<script>
import RexCodeEditor from '@/rex-components/rex-code-editor.vue';
import { sql } from '@codemirror/lang-sql';
import { basicSetup } from 'codemirror';
import {
  sqlKeywords,
  sqlContants,
  sqlBuildInFunctions,
  sqlDataTypes,
  LOG_DB_NAME,
  SQL_LANG_TYPE,
  lmTableNames,
  anlyTableNames,
} from '@/components/Log/log.constants';
import { mapState } from 'vuex';

export default {
  components: { RexCodeEditor },
  props: {
    editorValue: {
      type: String,
      default: '',
    },
    // provide sql or plain_text
    editorType: {
      type: String,
      default: SQL_LANG_TYPE,
    },
  },
  computed: {
    ...mapState('logState/logCommonState', ['sourceList', 'isADType']),
    getSources() {
      return (
        this.sourceList
          ?.filter((sourceObj) => sourceObj?.name)
          ?.map((sourceObj) => sourceObj.name) || []
      );
    },
    getAutocompletions() {
      const tableNames = this.isADType ? anlyTableNames : lmTableNames;
      return this.editorType === SQL_LANG_TYPE
        ? [
            ...this.getMappedKeywords(
              [
                ...sqlKeywords,
                ...sqlDataTypes,
                ...sqlBuildInFunctions,
                ...sqlContants,
                ...tableNames,
                LOG_DB_NAME,
              ],
              'keyword',
            ),
            ...this.getMappedKeywords(this.getSources, 'constant'),
          ]
        : [];
    },
  },
  methods: {
    getMappedKeywords(keys, type) {
      return keys.map((key) => ({ label: key, type }));
    },
  },
  setup(props) {
    const lang = props.editorType === SQL_LANG_TYPE ? sql() : basicSetup;

    return {
      lang,
    };
  },
};
</script>

<template>
  <div>
    <RexCodeEditor
      :value="editorValue"
      @input="(val) => $emit('onTextChange', val)"
      :autocompletions="getAutocompletions"
      :lang="lang"
    />
  </div>
</template>

<style lang="scss" scoped></style>
